export type StyleToHexColor = Readonly<Record<string, string>>;

export const styleToHexColor: StyleToHexColor = {
  orange: 'ff5f00',
  grayLight: '808080',
  'gray-light': '808080',
};
